import { render } from "./roleTable.vue?vue&type=template&id=0015482e&scoped=true"
import script from "./roleTable.vue?vue&type=script&lang=js"
export * from "./roleTable.vue?vue&type=script&lang=js"

import "./roleTable.vue?vue&type=style&index=0&id=0015482e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0015482e"]])

export default __exports__